import { render } from "./BranchViewer.vue?vue&type=template&id=23539896&scoped=true&ts=true"
import script from "./BranchViewer.vue?vue&type=script&lang=ts"
export * from "./BranchViewer.vue?vue&type=script&lang=ts"

import "./BranchViewer.vue?vue&type=style&index=0&id=23539896&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23539896"]])

export default __exports__